const NewOrder = () => {
  return (
    <div>NewOrder</div>
  )
}

export default NewOrder